import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

const Title = styled.div<Props>(
  {
    fontSize: '16px',
    color: 'var(--fett-text-primary)',
    fontWeight: 500,
  },
  (props) => {
    const { title, wrap } = props;
    return {
      width: wrap === 'wrap' ? '100%' : '',
      marginRight: title && wrap === 'nowrap' ? '24px' : '0px',
      marginBottom: title && wrap === 'wrap' ? '16px' : '0px',
    };
  },
);
const Container = styled.div<Props>(
  {
    display: 'flex',
    marginBottom: '32px',
    alignItems: 'center',
  },
  (props) => {
    const { wrap } = props;
    return {
      flexWrap: wrap,
    };
  },
);

interface Props extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  wrap?: 'wrap' | 'nowrap';
}

const SettingItemContainer = (props: Props) => {
  const { title, wrap = 'nowrap', children, ...otherProps } = props;
  return (
    <Container wrap={wrap} {...otherProps}>
      {title && (
        <Title title={title} wrap={wrap}>
          {title}
        </Title>
      )}
      {children}
    </Container>
  );
};

export default SettingItemContainer;
